import { memo } from "react";
import { useLocation } from "react-router-dom";
import { PanelLeft } from "lucide-react";
import { ALL_NAV } from "@/router/navigation";
import { useAppStore } from "@/stores";
import { Button, SearchBox, Kbd } from "@/components/ui";

/**
 * Toolbar
 *
 * The top bar of the main area. Shows the current page title, a search /
 * command affordance, and doubles as the window drag region on frameless
 * platforms. Interactive controls opt out of dragging with `no-drag`.
 */
export const Toolbar = memo(function Toolbar() {
  const { pathname } = useLocation();
  const openPalette = useAppStore((s) => s.setCommandPaletteOpen);
  const collapsed = useAppStore((s) => s.sidebarCollapsed);
  const toggleSidebar = useAppStore((s) => s.toggleSidebar);

  const active = ALL_NAV.find((n) => pathname.startsWith(n.path));

  return (
    <header className="drag-region flex h-11 shrink-0 items-center gap-3 border-b border-white/5 bg-bg-base/70 px-3 backdrop-blur-xl backdrop-saturate-150">
      {collapsed && (
        <Button
          variant="ghost"
          size="sm"
          className="no-drag h-7 w-7 p-0"
          onClick={toggleSidebar}
          aria-label="Expand sidebar"
        >
          <PanelLeft size={15} strokeWidth={1.75} />
        </Button>
      )}

      <h1 className="text-md font-semibold tracking-tight text-text-primary">
        {active?.label ?? "Seufic AI"}
      </h1>

      <div className="flex-1" />

      <div className="no-drag w-64">
        <SearchBox
          readOnly
          placeholder="Search…"
          onFocus={() => openPalette(true)}
          onClick={() => openPalette(true)}
          hint={<Kbd>⌘K</Kbd>}
        />
      </div>
    </header>
  );
});
